
<div class="spinner-loader-container" *ngIf="loaderSpinnerService.displaySpinner">
	<mat-progress-spinner
		attr.aria-label="{{ 'application_features.loading' | translate }}"
        class="carm-loader-spinner mat-spinner-color"
        mode="indeterminate"
        value="50">
    </mat-progress-spinner>
</div>
